import { styled } from "@mui/material/styles";
import { Stack, Typography, Box } from "@mui/material";
import Containter from "components/Containter";
import { ReactNode } from "react";
import {
  Github,
  Telegram,
  Twitter,
  Discord,
  LogoWhite,
  BounceClub,
} from "components/Svg";
import Grid from "@mui/material/Unstable_Grid2";
import { NavLink } from "react-router-dom";

const Footer1Box = styled(Stack)`
  background: #272727;
`;

const Footer2Box = styled(Stack)`
  background: #191919;
`;

const Footer1Title = styled(Typography)`
  color: #fff;
  font-family: Arboria-Medium;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Footer1Info = styled(Typography)<{ isComing: boolean; desc?: string }>`
  color: rgba(255, 255, 255, 0.6);
  font-family: Arboria-Book;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
  cursor: pointer;
  &:hover {
    color: ${({ isComing }) =>
      isComing ? "rgba(255, 255, 255, 0.6)" : "#fff"};
    /* &::before {
      display: block;
      position: absolute;
      content: "hi@bracle.network";
      font-size: 8px;
      width: 130px;
      color: #fff;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 21px;
      padding: 5px 8px;
      top: -5px;
      right: -150px;
    } */
  }
  &::after {
    display: ${({ isComing }) => (isComing ? "block" : "none")};
    position: absolute;
    content: "Coming Soon";
    font-size: 8px;
    color: #fff;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 21px;
    padding: 3px 5px;
    top: -5px;
    right: -65px;
  }
`;

const Footer2Text = styled(Typography)`
  color: rgba(255, 255, 255, 0.6);
  font-family: Arboria-Medium;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const GridLogoWhite = styled(Grid)`
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  })};
`;

const Footer1Desc = styled("a")`
  color: #fff;
  font-family: Arboria-Book;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  margin-left: 3px;
`;

const Footer1Item = styled(Stack)`
  .fill-color {
    fill: rgba(255, 255, 255, 0.6);
  }
  &:hover {
    .fill-color {
      fill: #fff;
    }
  }
`;

interface subConItem {
  name: string;
  path: string;
  icon?: ReactNode;
  isComing?: boolean;
  target?: string;
  desc?: string;
}

interface FooterItem {
  name: string;
  subCon: subConItem[];
}

const Footer = () => {
  // const theme = useTheme();
  // const downToMd = useMediaQuery(theme.breakpoints.down("md"));
  const goTop = () => {
    document.body.scrollTop = 0;
  };
  const footerData: FooterItem[] = [
    {
      name: "Products & Services",
      subCon: [
        {
          name: "Prices Feeds",
          path: "/services/price-feeds",
        },
        {
          name: "Watch Tower",
          path: "",
          isComing: true,
        },
        // {
        //   name: "Data Providers",
        //   path: "/ecosystem/data-provider",
        // },
        // {
        //   name: "Node Operators",
        //   path: "",
        // },
        // {
        //   name: "Staking &Restaking",
        //   path: "/staking",
        // },
      ],
    },
    {
      name: "Resource",
      subCon: [
        {
          name: "Docs",
          path: "https://docs.bracle.network/",
          target: "_blank",
        },
        // {
        //   name: "Developers",
        //   path: "",
        // },
        {
          name: "Brand Assets",
          path: "https://drive.google.com/drive/folders/1RJHW3YWSW8ug-ZP9QUIZKv_1Ua2QV0f9?usp=sharing",
          target: "_blank",
        },
      ],
    },
    {
      name: "Community",
      subCon: [
        {
          name: "Twitter",
          icon: <Twitter />,
          path: "https://twitter.com/BracleNetwork",
          target: "_blank",
        },
        {
          name: "BounceClub",
          icon: (
            <Box mt={3}>
              <BounceClub />
            </Box>
          ),
          path: "https://app.bouncebit.io/club/54217",
          target: "_blank",
        },
        // {
        //   name: "Telegram",
        //   icon: (
        //     <Box ml={-3}>
        //       <Telegram />
        //     </Box>
        //   ),
        //   path: "https://t.me/BracleNetwork",
        //   target: "_blank",
        // },
        // {
        //   name: "Discord",
        //   icon: <Discord />,
        //   path: "",
        // },
        {
          name: "Github",
          icon: <Github />,
          path: "https://github.com/0xBracle",
          target: "_blank",
        },
      ],
    },
    {
      name: "Statement",
      subCon: [
        {
          name: "Privacy Policy",
          path: "/privacy-policy",
        },
        {
          name: "Terms of Service",
          path: "/terms",
        },
      ],
    },
    {
      name: "Others",
      subCon: [
        // {
        //   name: "Bug Bounty",
        //   path: "",
        // },
        {
          name: "Contact:",
          path: "mailto:hi@bracle.network",
          desc: "hi@bracle.network",
        },
        // {
        //   name: "Airdrop",
        //   path: "",
        //   desc: "Participate in Bracle Network's growth and earn token rewarded",
        // },
      ],
    },
  ];
  return (
    <Box>
      <Footer1Box>
        <Containter>
          <Stack py={60}>
            <Grid container spacing={10}>
              <GridLogoWhite xs={12} md={2}>
                <LogoWhite />
              </GridLogoWhite>
              {footerData.map((d: FooterItem, index: number) => (
                <>
                  <Grid xs={12} md={2} mb={20}>
                    <Box mb={10}>
                      <Footer1Title>{d.name}</Footer1Title>
                    </Box>
                    {d.subCon.map((subItem: subConItem) => (
                      <>
                        {subItem?.isComing ? (
                          <>
                            <Footer1Item
                              justifyContent="start"
                              alignItems="center"
                              direction="row"
                              mt={15}
                            >
                              <Footer1Info
                                isComing={subItem?.isComing || false}
                                desc={subItem?.desc || ""}
                              >
                                {subItem.name}
                              </Footer1Info>
                            </Footer1Item>
                          </>
                        ) : (
                          <NavLink
                            onClick={() => {
                              !subItem.desc && goTop();
                            }}
                            to={subItem.path}
                            target={subItem?.target || ""}
                          >
                            <Footer1Item
                              justifyContent="start"
                              alignItems="center"
                              direction="row"
                              mt={15}
                            >
                              {subItem?.icon && (
                                <Box mr={10}>{subItem?.icon}</Box>
                              )}
                              <Box>
                                <Footer1Info
                                  isComing={subItem?.isComing || false}
                                >
                                  {subItem.name}
                                  {subItem.desc && (
                                    <Footer1Desc
                                      target="_blank"
                                      href={subItem.path}
                                    >
                                      {subItem.desc}
                                    </Footer1Desc>
                                  )}
                                </Footer1Info>
                              </Box>
                            </Footer1Item>
                          </NavLink>
                        )}
                      </>
                    ))}
                  </Grid>
                </>
              ))}
            </Grid>
          </Stack>
        </Containter>
      </Footer1Box>
      <Footer2Box
        justifyContent="center"
        alignItems="center"
        direction="row"
        py={15}
      >
        <Footer2Text>© 2024 Bracle . All rights reserved.</Footer2Text>
      </Footer2Box>
    </Box>
  );
};

export default Footer;
